var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEventsPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 413,
    height: 445,
    viewBox: "0 0 413 445",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M276.363 106.31C276.363 106.31 233.303 80.3581 183.9 100.08C134.497 119.803 103.01 171.103 76.5202 211.962C50.0304 252.822 54.0613 300.072 85.1354 326.986C116.21 353.9 144.376 327.787 192.788 335.138C241.2 342.49 252.987 352.28 297.599 330.288C342.211 308.296 360.375 240.398 336.966 183.438C313.557 126.478 276.363 106.31 276.363 106.31Z",
    fill: "#448BCA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M276.363 106.31C276.363 106.31 233.303 80.3581 183.9 100.08C134.497 119.803 103.01 171.103 76.5202 211.962C50.0304 252.822 54.0613 300.072 85.1354 326.986C116.21 353.9 144.376 327.787 192.788 335.138C241.2 342.49 252.987 352.28 297.599 330.288C342.211 308.296 360.375 240.398 336.966 183.438C313.557 126.478 276.363 106.31 276.363 106.31Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M349.952 381.409C349.952 384.898 285.598 387.728 206.228 387.728C126.858 387.728 62.5039 384.898 62.5039 381.409C62.5039 377.921 126.849 375.082 206.228 375.082C285.606 375.082 349.952 377.912 349.952 381.409Z",
    fill: "#448BCA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M349.952 381.409C349.952 384.898 285.598 387.728 206.228 387.728C126.858 387.728 62.5039 384.898 62.5039 381.409C62.5039 377.921 126.849 375.082 206.228 375.082C285.606 375.082 349.952 377.912 349.952 381.409Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M330.326 317.641C328.327 320.137 326.976 323.158 326.41 326.399L318.563 331.142V308.723L318.712 308.955L331.226 299.084C332.804 299.351 338.875 300.099 344.442 296.886C350.819 293.157 355.51 280.35 355.51 280.35C355.51 280.35 340.205 278.49 335.017 285.405C332.172 288.995 330.658 293.591 330.763 298.31L318.563 307.94V291.386C320.847 290.24 322.866 288.561 324.473 286.47C326.08 284.38 327.236 281.931 327.856 279.3C330.078 269.981 318.225 251.621 318.225 251.621C318.225 251.621 305.876 270.515 308.313 280.101C310.403 288.218 316.028 290.781 317.704 291.386V327.297L308.924 319.403C309.122 317.516 309.279 311.598 304.389 305.662C298.459 298.479 282.657 299.013 282.657 299.013C282.657 299.013 289.323 313.378 295.047 318.175C300.003 322.358 306.859 320.649 308.503 320.151L317.77 328.472V339.384H303.968L309.585 377.209H326.435L332.052 339.384H318.563V332.166L327.187 326.959C329.285 327.582 335.15 328.882 340.7 325.891C347.614 322.18 353.288 314.17 353.288 314.17C353.288 314.17 336.744 309.658 330.326 317.641Z",
    fill: "#448BCA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M330.326 317.641C328.327 320.137 326.976 323.158 326.41 326.399L318.563 331.142V308.723L318.712 308.955L331.226 299.084C332.804 299.351 338.875 300.099 344.442 296.886C350.819 293.157 355.51 280.35 355.51 280.35C355.51 280.35 340.205 278.49 335.017 285.405C332.172 288.995 330.658 293.591 330.763 298.31L318.563 307.94V291.386C320.847 290.24 322.866 288.561 324.473 286.47C326.08 284.38 327.236 281.931 327.856 279.3C330.078 269.981 318.225 251.621 318.225 251.621C318.225 251.621 305.876 270.515 308.313 280.101C310.403 288.218 316.028 290.781 317.704 291.386V327.297L308.924 319.403C309.122 317.516 309.279 311.598 304.389 305.662C298.459 298.479 282.657 299.013 282.657 299.013C282.657 299.013 289.323 313.378 295.047 318.175C300.003 322.358 306.859 320.649 308.503 320.151L317.77 328.472V339.384H303.968L309.585 377.209H326.435L332.052 339.384H318.563V332.166L327.187 326.959C329.285 327.582 335.15 328.882 340.7 325.891C347.614 322.18 353.288 314.17 353.288 314.17C353.288 314.17 336.744 309.658 330.326 317.641Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M296.105 103.249H107.091C101.772 103.249 97.46 107.895 97.46 113.626V241.973C97.46 247.704 101.772 252.351 107.091 252.351H296.105C301.424 252.351 305.736 247.704 305.736 241.973V113.626C305.736 107.895 301.424 103.249 296.105 103.249Z",
    fill: "#448BCA",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M295.645 103H106.631C101.312 103 97 107.646 97 113.377V241.724C97 247.456 101.312 252.102 106.631 252.102H295.645C300.964 252.102 305.276 247.456 305.276 241.724V113.377C305.276 107.646 300.964 103 295.645 103Z",
    fill: "#448BCA",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M185.305 186.606H160.938V201.336H185.305V186.606Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M185.305 203.997H160.938V218.726H185.305V203.997Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M212.15 186.606H187.783V201.336H212.15V186.606Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M239.004 169.207H214.637V183.936H239.004V169.207Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M239.004 151.807H214.637V166.537H239.004V151.807Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M239.004 119.652H214.637V131.738H239.004V119.652Z",
    fill: "#263238"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M212.15 119.652H187.783V131.738H212.15V119.652Z",
    fill: "#263238"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M212.15 203.997H187.783V218.726H212.15V203.997Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M212.15 134.408H187.783V149.137H212.15V134.408Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M212.15 151.807H187.783V166.537H212.15V151.807Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M212.15 169.207H187.783V183.936H212.15V169.207Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M239.004 203.997H214.637V218.726H239.004V203.997Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M131.607 134.408H105.629V149.137H131.607V134.408Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M131.607 169.207H105.629V183.936H131.607V169.207Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M131.607 186.606H105.629V201.336H131.607V186.606Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M131.607 151.807H105.629V166.537H131.607V151.807Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M294.313 119.652H268.335V131.738H294.313V119.652Z",
    fill: "#263238"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M131.607 203.997H105.629V218.726H131.607V203.997Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M265.848 134.408H241.481V149.137H265.848V134.408Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M239.004 186.606H214.637V201.336H239.004V186.606Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M265.848 186.606H241.481V201.336H265.848V186.606Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M265.848 151.807H241.481V166.537H265.848V151.807Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M265.848 169.207H241.481V183.936H265.848V169.207Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M265.848 203.997H241.481V218.726H265.848V203.997Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M239.004 134.408H214.637V149.137H239.004V134.408Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M294.313 203.997H268.335V218.726H294.313V203.997Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M265.848 119.652H241.481V131.738H265.848V119.652Z",
    fill: "#263238"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M294.313 186.606H268.335V201.336H294.313V186.606Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M265.848 221.396H241.481V236.962H265.848V221.396Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M294.313 169.207H268.335V183.936H294.313V169.207Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M212.15 221.396H187.783V236.962H212.15V221.396Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M239.004 221.396H214.637V236.962H239.004V221.396Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M294.313 151.807H268.335V166.537H294.313V151.807Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M294.313 221.396H268.335V236.962H294.313V221.396Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M131.607 221.396H105.629V236.962H131.607V221.396Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M294.313 134.408H268.335V149.137H294.313V134.408Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M131.607 119.652H105.629V131.738H131.607V119.652Z",
    fill: "#263238"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M158.452 119.652H134.085V131.738H158.452V119.652Z",
    fill: "#263238"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M158.452 186.606H134.085V201.336H158.452V186.606Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M185.305 119.652H160.938V131.738H185.305V119.652Z",
    fill: "#263238"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M185.305 151.807H160.938V166.537H185.305V151.807Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M158.452 203.997H134.085V218.726H158.452V203.997Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M185.305 134.408H160.938V149.137H185.305V134.408Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M158.452 134.408H134.085V149.137H158.452V134.408Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M185.305 169.207H160.938V183.936H185.305V169.207Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M158.452 169.207H134.085V183.936H158.452V169.207Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M158.452 221.396H134.085V236.962H158.452V221.396Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M158.452 151.807H134.085V166.537H158.452V151.807Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M185.305 221.396H160.938V236.962H185.305V221.396Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M117.094 111.526C119.032 111.526 120.604 109.832 120.604 107.743C120.604 105.654 119.032 103.961 117.094 103.961C115.155 103.961 113.583 105.654 113.583 107.743C113.583 109.832 115.155 111.526 117.094 111.526Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M132.491 107.743C132.492 106.993 132.287 106.259 131.901 105.634C131.515 105.009 130.966 104.521 130.322 104.233C129.679 103.945 128.971 103.87 128.287 104.016C127.604 104.162 126.976 104.523 126.484 105.054C125.991 105.584 125.656 106.261 125.52 106.997C125.385 107.733 125.455 108.496 125.723 109.19C125.99 109.883 126.442 110.475 127.022 110.891C127.602 111.307 128.283 111.528 128.98 111.526C129.911 111.526 130.804 111.127 131.462 110.418C132.121 109.709 132.491 108.747 132.491 107.743Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M117.16 110.209C116.672 110.209 116.203 110 115.858 109.627C115.512 109.255 115.318 108.75 115.318 108.224V94.8028C115.317 94.5414 115.364 94.2824 115.456 94.0406C115.548 93.7987 115.684 93.5789 115.855 93.3937C116.026 93.2084 116.23 93.0614 116.454 92.9611C116.678 92.8608 116.918 92.8092 117.16 92.8092C117.651 92.8092 118.122 93.0192 118.469 93.3931C118.816 93.767 119.011 94.2741 119.011 94.8028V108.224C119.011 108.485 118.963 108.744 118.87 108.986C118.777 109.227 118.64 109.446 118.468 109.631C118.296 109.815 118.092 109.961 117.868 110.06C117.643 110.159 117.403 110.21 117.16 110.209Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M129.154 110.209C128.665 110.209 128.196 110 127.851 109.627C127.506 109.255 127.312 108.75 127.312 108.224V94.8028C127.31 94.5414 127.357 94.2824 127.449 94.0406C127.541 93.7987 127.677 93.5789 127.848 93.3937C128.019 93.2084 128.223 93.0614 128.447 92.9611C128.671 92.8608 128.911 92.8092 129.154 92.8092C129.644 92.8092 130.115 93.0192 130.462 93.3931C130.809 93.767 131.004 94.2741 131.004 94.8028V108.224C131.004 108.485 130.956 108.744 130.863 108.986C130.77 109.227 130.633 109.446 130.461 109.631C130.289 109.815 130.085 109.961 129.861 110.06C129.637 110.159 129.396 110.21 129.154 110.209Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M279.122 107.743C279.124 106.993 278.919 106.259 278.533 105.634C278.147 105.009 277.597 104.521 276.954 104.233C276.311 103.945 275.603 103.87 274.919 104.016C274.236 104.162 273.608 104.523 273.116 105.054C272.623 105.584 272.288 106.261 272.152 106.997C272.017 107.733 272.087 108.496 272.354 109.19C272.622 109.883 273.074 110.475 273.654 110.891C274.234 111.307 274.915 111.528 275.612 111.526C276.543 111.526 277.436 111.127 278.094 110.418C278.753 109.709 279.122 108.747 279.122 107.743Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M287.49 111.526C289.429 111.526 291 109.832 291 107.743C291 105.654 289.429 103.961 287.49 103.961C285.551 103.961 283.979 105.654 283.979 107.743C283.979 109.832 285.551 111.526 287.49 111.526Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M275.669 110.209C275.181 110.209 274.712 110 274.367 109.627C274.021 109.255 273.827 108.75 273.827 108.224V94.8028C273.826 94.5414 273.873 94.2824 273.965 94.0406C274.057 93.7987 274.193 93.5789 274.364 93.3937C274.535 93.2084 274.738 93.0614 274.962 92.9611C275.186 92.8608 275.427 92.8092 275.669 92.8092C276.16 92.8092 276.63 93.0192 276.977 93.3931C277.324 93.767 277.519 94.2741 277.519 94.8028V108.224C277.519 108.485 277.471 108.744 277.378 108.986C277.285 109.227 277.149 109.446 276.977 109.631C276.805 109.815 276.601 109.961 276.377 110.06C276.152 110.159 275.912 110.21 275.669 110.209Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M287.671 110.209C287.426 110.213 287.183 110.166 286.956 110.068C286.729 109.97 286.522 109.825 286.347 109.64C286.172 109.455 286.034 109.235 285.939 108.992C285.845 108.749 285.796 108.488 285.796 108.224V94.8028C285.796 94.2741 285.991 93.767 286.338 93.3931C286.685 93.0192 287.155 92.8092 287.646 92.8092C287.889 92.8092 288.129 92.8608 288.353 92.9611C288.577 93.0614 288.78 93.2084 288.952 93.3937C289.123 93.5789 289.258 93.7987 289.35 94.0406C289.442 94.2824 289.489 94.5414 289.488 94.8028V108.224C289.488 108.746 289.297 109.247 288.957 109.618C288.617 109.989 288.155 110.202 287.671 110.209Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M196.357 111.526C198.296 111.526 199.868 109.832 199.868 107.743C199.868 105.654 198.296 103.961 196.357 103.961C194.418 103.961 192.847 105.654 192.847 107.743C192.847 109.832 194.418 111.526 196.357 111.526Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M208.235 111.526C210.174 111.526 211.746 109.832 211.746 107.743C211.746 105.654 210.174 103.961 208.235 103.961C206.296 103.961 204.725 105.654 204.725 107.743C204.725 109.832 206.296 111.526 208.235 111.526Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M196.415 110.209C195.927 110.209 195.458 110 195.113 109.627C194.767 109.255 194.573 108.75 194.573 108.224V94.8028C194.572 94.5414 194.619 94.2824 194.711 94.0406C194.803 93.7987 194.939 93.5789 195.11 93.3937C195.281 93.2084 195.484 93.0614 195.708 92.9611C195.932 92.8608 196.173 92.8092 196.415 92.8092C196.906 92.8092 197.377 93.0192 197.724 93.3931C198.071 93.767 198.265 94.2741 198.265 94.8028V108.224C198.265 108.485 198.218 108.744 198.124 108.986C198.031 109.227 197.895 109.446 197.723 109.631C197.551 109.815 197.347 109.961 197.123 110.06C196.898 110.159 196.658 110.21 196.415 110.209Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M208.408 110.209C207.92 110.209 207.451 110 207.106 109.627C206.76 109.255 206.566 108.75 206.566 108.224V94.8028C206.565 94.5414 206.612 94.2824 206.704 94.0406C206.796 93.7987 206.932 93.5789 207.103 93.3937C207.274 93.2084 207.478 93.0614 207.702 92.9611C207.926 92.8608 208.166 92.8092 208.408 92.8092C208.651 92.8092 208.892 92.8608 209.116 92.961C209.341 93.0611 209.545 93.208 209.717 93.3931C209.889 93.5782 210.025 93.798 210.118 94.0399C210.211 94.2818 210.259 94.541 210.259 94.8028V108.224C210.259 108.485 210.211 108.744 210.118 108.986C210.025 109.227 209.888 109.446 209.716 109.631C209.544 109.815 209.34 109.961 209.116 110.06C208.891 110.159 208.651 110.21 208.408 110.209Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M122.496 153.089L110.205 164.766",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M113.988 153.089L122.496 163.983",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M258.53 136.482L246.239 148.149",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M250.022 136.482L258.53 147.375",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M177.987 136.482L165.688 148.149",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M169.471 136.482L177.987 147.375",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M286.647 136.152L274.348 147.829",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M278.131 136.152L286.647 147.046",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M158.096 174.022C158.096 174.022 161.888 179.202 162.276 180.341C162.55 181.17 162.776 182.018 162.953 182.877L165.431 184.853C165.509 184.913 165.575 184.99 165.624 185.079C165.673 185.168 165.705 185.267 165.718 185.369C165.73 185.472 165.723 185.576 165.696 185.676C165.67 185.775 165.625 185.868 165.564 185.948L163.688 188.431C163.688 188.431 165.431 194.661 165.34 195.551C165.25 196.441 159.195 198.657 159.195 198.657L158.633 203.427L147.152 203.267L147.111 194.429L142.526 182.859C142.526 182.859 146.632 174.511 158.096 174.022Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M156.113 191.457L157.658 191.279C157.816 192.019 158.112 192.717 158.53 193.33C158.948 193.942 159.477 194.456 160.086 194.839",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M156.113 191.457L157.658 191.279C157.816 192.019 158.112 192.717 158.53 193.33C158.948 193.942 159.477 194.456 160.086 194.839",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M144.962 174.315C144.962 174.315 140.626 174.538 140.65 181.008C140.675 187.479 146.755 193.468 147.085 194.421C147.415 195.373 150.67 194.928 152.958 194.011C154.238 193.562 155.34 192.662 156.088 191.457C156.088 191.457 153.9 188.021 154.346 187.007C154.792 185.992 157.137 186.962 157.137 186.962C157.657 186.645 158.125 186.239 158.525 185.761C158.922 185.165 161.044 182.592 159.574 181.24C158.104 179.887 155.816 179.068 156.832 177.359C157.848 175.65 161.482 173.986 160.417 170.31C159.351 166.635 156.972 166.75 154.99 167.952C153.007 169.153 152.462 165.282 148.605 167.48C144.747 169.679 143.665 172.891 144.962 174.315Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M150.034 186.989C149.952 187.674 149.952 188.368 150.034 189.054",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M156.725 176.594C156.725 176.594 155.899 178.24 152.595 181.435C151.437 182.555 150.614 184.02 150.232 185.645",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M157.502 179.86C157.502 179.86 154.14 184.773 152.372 186.233",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M191.375 174.565C194.791 176.334 198.398 177.638 202.113 178.445C202.113 178.445 196.818 174.582 191.697 173.621C191.226 173.55 190.97 174.342 191.375 174.565Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M190.392 203.81L196.703 186.402C196.703 186.402 194.225 182.014 194.225 180.688C194.225 179.362 198.173 174.591 198.173 174.591C198.173 174.591 198.495 172.001 200.213 173.239C200.709 173.606 201.109 174.106 201.372 174.689C201.636 175.273 201.754 175.92 201.717 176.567C202.51 177.771 203.23 179.028 203.873 180.332C204.269 181.364 200.519 187.105 200.519 187.105C200.519 187.105 199.891 202.92 198.239 208.358C196.587 213.796 196.174 214.926 195.076 216.519C193.977 218.112 188.757 215.309 188.757 215.309L190.392 203.81Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M161.541 371.771L171.808 375.794C172.049 375.882 172.269 376.024 172.456 376.21C172.643 376.396 172.792 376.621 172.893 376.873C172.994 377.124 173.045 377.396 173.043 377.669C173.041 377.943 172.986 378.214 172.882 378.464C172.74 378.768 172.494 379.001 172.196 379.113C170.891 379.621 157.328 384.631 153.372 382.825C152.968 382.606 152.628 382.272 152.387 381.859C152.147 381.446 152.016 380.971 152.009 380.484C152.14 377.2 152.474 373.93 153.008 370.694C153.008 370.694 158.047 373.266 161.541 371.771Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M172.898 378.472C173.006 378.24 173.066 377.985 173.073 377.725C173.081 377.466 173.035 377.207 172.939 376.968C170.098 378.455 164.06 381.24 158.559 381.347C156.374 381.492 154.181 381.291 152.05 380.751C152.102 381.188 152.251 381.605 152.484 381.967C152.717 382.33 153.027 382.627 153.388 382.833C157.369 384.613 170.907 379.629 172.212 379.122C172.511 379.01 172.757 378.777 172.898 378.472Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M133.076 368.407C133.076 368.407 132.151 377.583 132.647 378.49C133.143 379.398 134.621 380.012 137.165 379.834C137.945 379.816 138.7 379.533 139.322 379.027C139.945 378.521 140.404 377.816 140.634 377.013C140.866 376.354 140.271 370.356 140.254 369.306C140.238 368.255 133.076 368.407 133.076 368.407Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M140.66 375.295C139.875 376.924 138.875 377.965 136.282 378.019C134.948 378.077 133.629 377.698 132.499 376.933C132.46 377.457 132.511 377.985 132.647 378.49C133.151 379.38 134.622 380.012 137.166 379.834C137.945 379.816 138.7 379.533 139.323 379.027C139.945 378.521 140.404 377.816 140.635 377.013C140.707 376.443 140.715 375.867 140.66 375.295Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M167.034 262.826C164.623 264.111 162.081 265.088 159.459 265.736L136.687 260.067C136.687 260.067 135.175 273.826 135.216 276.194C135.258 278.561 136.042 321.165 136.042 321.165L132.937 369.047C133.259 369.762 133.767 370.359 134.399 370.767C135.031 371.175 135.76 371.375 136.497 371.344C138.008 371.336 139.5 370.981 140.874 370.302L150.638 320.462L152.81 373.373C152.81 373.373 154.156 374.77 157.229 374.699C158.129 374.667 159.004 374.379 159.767 373.865C160.53 373.351 161.154 372.628 161.574 371.771C161.574 371.771 163.086 351.301 165.34 336.651C167.595 322.002 167.868 281.676 167.868 281.676L167.034 262.826Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M145.376 270.044C148.363 270.742 151.406 271.12 154.462 271.174",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M136.934 267.401C136.934 267.401 137.991 268.913 140.791 268.913",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M160.037 359.044C160.037 359.044 162.135 331.89 163.539 312.283C164.387 300.735 164.503 289.138 163.886 277.573C163.886 277.573 167.389 273.426 164.935 266.261",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M160.037 362.061L158.988 370.738",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M150.613 320.471L148.118 284.925L142.295 278.89",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M138.413 243.317C138.533 242.912 138.528 242.477 138.399 242.075C138.269 241.674 138.022 241.329 137.694 241.092C135.166 239.25 129.038 235.458 127.08 240.451C126.508 242.4 126.109 244.402 125.89 246.432C125.345 250.428 125.544 277.484 125.568 280.252C125.569 280.402 125.552 280.552 125.519 280.697C125.304 281.756 124.404 286.384 125.031 289.143C125.733 292.285 127.08 294.706 129.368 295.373C131.656 296.041 132.903 293.193 132.548 291.448C132.193 289.704 133.044 288.351 132.688 286.607C132.399 285.201 131.16 281.525 130.689 280.163C130.576 279.827 130.547 279.465 130.607 279.113C131.251 275.553 134.861 255.59 135.133 254.629C135.406 253.668 137.521 246.423 138.413 243.317Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M128.683 289.74C128.683 289.74 131.598 291.938 131.937 293.967",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M129.607 287.915C129.607 287.915 131.92 289.544 132.54 290.825",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M130.028 286.073L130.854 287.301C130.854 287.301 131.267 292.196 132.556 291.466C133.844 290.736 133.085 284.8 133.085 284.8C133.085 284.8 132.432 283.349 130.417 279.887",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M130.028 286.073L130.854 287.301C130.854 287.301 131.267 292.196 132.556 291.466C133.844 290.736 133.085 284.8 133.085 284.8C133.085 284.8 132.432 283.349 130.417 279.887",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M129.88 280.955C130.325 282.709 130.285 284.565 129.764 286.295C129.02 287.801 128.193 289.258 127.286 290.656C128.497 291.904 129.631 293.236 130.681 294.643",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M131.334 211.206L123.842 240.87C123.842 240.87 130.111 246.343 137.884 246.21L142.898 218.05C142.898 218.05 137.297 204.495 131.334 211.206Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M143.724 201.478C143.724 201.478 132.722 207.37 131.689 210.04C130.863 212.265 133.391 228.018 133.44 230.786C133.49 233.554 135.687 257.335 136.282 261.936C136.876 266.537 151.15 268.495 156.585 266.724C162.02 264.953 167.067 264.277 167.034 262.799C167.001 261.322 166.274 248.808 166.571 246.414C166.869 244.02 169.173 226.06 169.173 226.06L189.914 221.432C189.914 221.432 190.872 220.809 190.897 216.768C190.9 212.955 190.718 209.143 190.352 205.35C187.665 206.044 184.887 206.231 182.141 205.902C177.136 205.421 171.205 203.97 170.148 204.291C169.09 204.611 161.888 202.991 159.517 202.671C156.221 202.19 147.854 199.182 143.724 201.478Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M134.489 244.777L131.606 218.726",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M132.391 230.065L130.986 226.674",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M169.172 226.016L161.086 227.422",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M167.389 226.674L161.441 232.708",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M185.586 206.685C185.586 206.685 179.985 215.736 166.34 219.145",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsPlaceholder);
export default __webpack_public_path__ + "static/media/events-placeholder.f2cde1cf874f955876ea8c61b92663d1.svg";
export { ForwardRef as ReactComponent };